import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import searchKeyword from './global-search-data.json';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss']
})
export class GlobalSearchComponent implements OnInit {
  @Input() public data$;
  title: any;
  displaySearch: any;
  searchKeyword: any;
  searchItem: any;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    const title = this.data$.data;
    this.title = title;
    this.searchKeyword = searchKeyword['default'];
    this.displaySearch = this.searchKeyword.filter(keyword => keyword.word.indexOf(this.title.toLowerCase()) !== -1);
    this.searchItem = this.displaySearch.length;
  }

  close() {
    this.activeModal.close();
  }
}
